<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">{{ $t("archive") }}</div>

    <!-- Statistics Section -->
    <div class="columns mb-6" v-if="stats">
      <div class="column">
        <div class="box has-text-centered">
          <p class="heading">{{ $t("total customers") }}</p>
          <p class="title is-2 has-text-primary">{{ stats.total_customers }}</p>
        </div>
      </div>
      <div class="column">
        <div class="box has-text-centered">
          <p class="heading">{{ $t("total expedients") }}</p>
          <p class="title is-2 has-text-info">{{ stats.total_expedients }}</p>
        </div>
      </div>
      <div class="column">
        <div class="box has-text-centered">
          <p class="heading">{{ $t("total files") }}</p>
          <p class="title is-2 has-text-success">{{ stats.total_files }}</p>
        </div>
      </div>
      <div class="column">
        <div class="box has-text-centered">
          <p class="heading">{{ $t("total categories") }}</p>
          <p class="title is-2 has-text-warning">
            {{ stats.total_categories }}
          </p>
        </div>
      </div>
      <div class="column">
        <div class="box has-text-centered">
          <p class="heading">{{ $t("total expedient types") }}</p>
          <p class="title is-2 has-text-danger">
            {{ stats.total_expedient_types }}
          </p>
        </div>
      </div>
    </div>

    <!-- Navigation Cards -->
    <div class="grid is-col-min-10">
      <div class="cell" @click="manage_customers">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/256/10857/10857085.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("customers") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cell" @click="manage_expedients">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/256/3281/3281289.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("expedients") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="cell" @click="manage_files">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/256/3767/3767084.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("files") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <div class="cell" @click="tree_view">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.freepik.com/256/3436/3436312.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("tree view") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cell" @click="manage_categories">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/256/2942/2942263.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("categories") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cell" @click="manage_expedient_types">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/256/2821/2821739.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("expedient types") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cell" @click="view_settings">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/256/3524/3524659.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("archive settings") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { get, error_message } from "@/utils";

export default {
  name: "ArchiveIndex",
  data() {
    return {
      stats: null,
      loading: false,
    };
  },
  methods: {
    manage_customers() {
      this.$router.push({ path: "/archive/customers" });
    },
    manage_expedients() {
      this.$router.push({ path: "/archive/expedients" });
    },
    manage_files() {
      this.$router.push({ path: "/archive/files" });
    },
    tree_view() {
      this.$router.push({ path: "/archive/tree-view" });
    },
    manage_categories() {
      this.$router.push({ path: "/archive/categories" });
    },
    manage_expedient_types() {
      this.$router.push({ path: "/archive/expedient-types" });
    },
    view_settings() {
      this.$router.push({ path: "/archive/settings" });
    },

    load_statistics() {
      let v = this;
      v.loading = true;

      get("/archive/file/stats")
        .then((data) => {
          v.stats = data;
        })
        .catch((error) => {
          console.error("Error loading statistics:", error);
          error_message(v.$t("error loading statistics"));
        })
        .finally(() => {
          v.loading = false;
        });
    },
  },
  created() {
    this.load_statistics();
  },
};
</script>

<style scoped>
.grid .cell .card:hover {
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}

.grid .cell .card:active {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
}

.grid .cell .card {
  background-color: rgba(20, 22, 26, 0.4);
}

.box {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.heading {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
}
</style>
